/** @jsx jsx */
import { jsx, Flex, Button } from 'theme-ui';
import { useTranslate } from '@modules';
import { Paragraph, SubTitle, SvgIcon, Link } from '@core';
import { FinnoscoreBannerProps } from './FinnoscoreBannerProps';
import { styles } from './DesktopFinnoscoreBanner.styles';

export const DesktopFinnoscoreBanner = ({ link, onClick, ...props }: FinnoscoreBannerProps) => {
  const __ = useTranslate();

  return (<Flex {...props} sx={styles.box}>
    <Flex sx={styles.content}>
      <Button variant="buttons.pure" onClick={onClick}>
        <Link to={link}>
          <Flex sx={styles.textContent}>
            <SubTitle sx={styles.title}>{__('finnoscoreBanner.title')}</SubTitle>
            <Flex sx={styles.paragraphContent}>
              <Paragraph sx={styles.paragraph}>{__('finnoscoreBanner.paragraph')}</Paragraph>
              <SvgIcon sx={styles.arrowIcon} name="tailedArrow" />
            </Flex>
          </Flex>
        </Link>
      </Button>
      <Button variant="buttons.pure" onClick={onClick} aria-label="close">
        <SvgIcon sx={styles.closeIcon} name="close" />
      </Button>
    </Flex>
  </Flex>
  );
};
